<template>
  <div class="login-page">
    <el-card>
      <h1 style="text-align:center;font-size:32px;font-weight:bold;margin-bottom:20px;">alpha-cex 后台管理</h1>
      <el-form :model="form" label-width="110px" ref="loginForm" @submit.native.prevent="onSubmit">
        <el-form-item
          label="账号："
          :rules="{
            required: true, message: '请输入账号'
          }"
        >
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item
          label="密码："
          :rules="{
            required: true, message: '请输入密码'
          }"
        >
          <el-input
            type="password"
            v-model="form.password">
          </el-input>
        </el-form-item>
        <el-form-item
          class="phone-code-form-item"
          label="手机验证码："
          prop="code"
          :rules="{
            required: true, message: '请输入手机验证码'
          }"
        >
          <el-input v-model="form.code"></el-input>
          <el-button @click.prevent="handlePhoneCode" :disabled="!form.username || !enableSendPhoneCode">
            <span v-if="!enableSendPhoneCode">{{this.timeDelay}}s</span>
            <span v-if="enableSendPhoneCode">获取验证码</span>
          </el-button>
        </el-form-item>

        <el-form-item class="actions">
          <el-button
            type="primary"
            native-type="submit"
            class="login-btn"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'LoginPage',
  data() {
    return {
      form: {},
      timeDelay: 60,
      enableSendPhoneCode: true
    };
  },
  methods: {
    ...mapActions(['login', 'getPhoneCode', 'getRightsDetail']),
    onSubmit() {
      this.$refs['loginForm'].validate(valid => {
        if (valid) {
          this.login(this.form).then(() => {
            this.$router.push({ path: '/home' });
          });
        }
      });
    },
    handlePhoneCode() {
      this.getPhoneCode(this.form.username).then(() => {
        this.$message.success('验证码已发送，请注意查收。');
        this.enableSendPhoneCode = false;
        this.timeInterval();
      });
    },
    timeInterval() {
      const interval = setInterval(() => {
        this.timeDelay--;
        if (this.timeDelay === 0) {
          this.enableSendPhoneCode = true;
          this.timeDelay = 60;
          clearInterval(interval);
        }
      }, 1000);
    }
  }
};
</script>

<style lang="less" scoped>
.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.login-page .el-card {
  padding: 20px;
  min-width: 350px;
}
.actions {
  margin-bottom: 0;
}
.actions /deep/ .el-form-item__content {
  margin-left: 0 !important;
}
.login-btn {
  width: 100%;
  font-size: 16px;
}
.forget-link {
  font-size: 14px;
  float: right;
}
.phone-code-form-item {
  /deep/ .el-form-item__content {
    display: flex;
    align-items: flex-start;
    .el-input {
      .el-input__inner {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    .el-button {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left: 0;
      width: 115px;
    }
  }
}
</style>
